import { useState } from "react";
import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";

export function CycleCountDetailsViewModel(logout, cycleCountId, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [cycleCount, setCycleCount] = useState({
    name: "",
    correct_items: [],
    wrong_items: [],
    items_missing: [],
    shipped_items: [],
    locked_items: [],
  });
  const [loading, setLoading] = useState(true);
  const [selectedRelocationItems, setSelectedRelocationItems] = useState([]);
  const [selectedMissingItems, setSelectedMissingItems] = useState([]);
  const [selectedShippingItems, setSelectedShippingItems] = useState([]);
  const [selectedLockedItems, setSelectedLockedItems] = useState([]);
  const [relocateInProgress, setRelocateInProgress] = useState(false);
  const [navigateUserAfterDeletion, setNavigateUserAfterDeletion] =
    useState(false);

  const getCycleCountDetails = async function () {
    let callResult = await makeGetApiCall(`cycleCounts/${cycleCountId}`);

    if (callResult.success) {
      setCycleCount(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const getCorrectItemsGroupedByPlu = async function (search) {
    let callResult = await makePostApiCall(`cycleCounts/correctItemsGroupedByPlu`, {
      cycle_id: cycleCountId,
      warehouse_location_id: cycleCount.warehouse_location_id,
      search: search,
    });

    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
    setLoading(false);
  };

const getWrongItemsGroupedByPlu = async function (search) {
  let callResult = await makePostApiCall(`cycleCounts/wrongItemsGroupedByPlu`, {
    cycle_id: cycleCountId,
    warehouse_location_id: cycleCount.warehouse_location_id,
    search: search,
  });

  if (callResult.success) {
  } else {
    if (callResult.errorStatus === 401) {
      logout();
    }
    showErrorModal(callResult.data.message);
  }
  return callResult;
  setLoading(false);
};

const getMissingItemsGroupedByPlu = async function (search) {
  let callResult = await makePostApiCall(`cycleCounts/missingItemsGroupedByPlu`, {
    cycle_id: cycleCountId,
    warehouse_location_id: cycleCount.warehouse_location_id,
    search: search,
  });

  if (callResult.success) {
  } else {
    if (callResult.errorStatus === 401) {
      logout();
    }
    showErrorModal(callResult.data.message);
  }
  return callResult;
  setLoading(false);
};

const getShippedItemsGroupedByPlu = async function (search) {
  let callResult = await makePostApiCall(`cycleCounts/shippedItemsGroupedByPlu`, {
    cycle_id: cycleCountId,
    warehouse_location_id: cycleCount.warehouse_location_id,
    search: search,
  });

  if (callResult.success) {
  } else {
    if (callResult.errorStatus === 401) {
      logout();
    }
    showErrorModal(callResult.data.message);
  }
  return callResult;
  setLoading(false);
};

const getLockedItemsGroupedByPlu = async function (search) {
  let callResult = await makePostApiCall(`cycleCounts/lockedItemsGroupedByPlu`, {
    cycle_id: cycleCountId,
    warehouse_location_id: cycleCount.warehouse_location_id,
    search: search,
  });

  if (callResult.success) {
  } else {
    if (callResult.errorStatus === 401) {
      logout();
    }
    showErrorModal(callResult.data.message);
  }
  return callResult;
  setLoading(false);
};


  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const updateCycleCountStatus = async function (payload) {
    let callResult = await makePutApiCall(`cycleCounts/${cycleCountId}`, {
      ...payload,
    });

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const printCycleCountSummary = async function () {
    let callResult = await makePostApiCall(
      `generateCycleCountReportSummary/${cycleCountId}`
    );

    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const printCycleCountDetails = async function () {
    let callResult = await makePostApiCall(
      `generateCycleCountReportDetails/${cycleCountId}`
    );

    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const deleteCycleCount = async function () {
    let callResult = await makePostApiCall(
      `deleteCycleCount/${cycleCountId}`,
      {}
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setNavigateUserAfterDeletion(true);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteCycleCount = function () {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteCycleCount()}
          message={`Are you sure you want to delete cycle count ${cycleCount.name} in room ${cycleCount.warehouse_location_name}?`}
          hideReason={true}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const relocateItems = async function (itemsList = selectedRelocationItems) {
    let callResult = await makePostApiCall(`relocateItemsFromCycleCount`, {
      items: itemsList,
      cycle_count_id: cycleCountId,
    });
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      getCycleCountDetails();
      setSelectedRelocationItems([]);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askRelocateItem = function (item) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Relocate"
          confirmAction={() => relocateItems([item])}
          message={`Are you sure you want to relocate item ${item.product_name} - ${item.barcode}?`}
          hideReason={true}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const askRelocateMultipleItems = function () {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Relocate"
          confirmAction={() => relocateItems()}
          message={`Are you sure you want to relocate selected items?`}
          hideReason={true}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const markItemsMissing = async function (itemsList = selectedMissingItems) {
    let callResult = await makePostApiCall(`markAsItemsMissingCycleCount`, {
      items: itemsList,
      cycle_count_id: cycleCountId,
    });
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      getCycleCountDetails();
      setSelectedMissingItems([]);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askMarkItemMissing = function () {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="YES"
          confirmAction={() => markItemsMissing()}
          message={`Are you sure you want to mark selected items missing?`}
          hideReason={true}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const askDeleteShippedItemsFromCC = async function (
    itemsList = selectedShippingItems
  ) {
    let callResult = await makePostApiCall(`deleteShippedItemsFromCycleCount`, {
      items: itemsList,
      cycle_count_id: cycleCountId,
    });
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      getCycleCountDetails();
      setSelectedShippingItems([]);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askUnlockLockedItems = async function (
    itemsList = selectedLockedItems
  ) {
    let callResult = await makePostApiCall(`unlockLockedItemsFromCycleCount`, {
      items: itemsList,
      cycle_count_id: cycleCountId,
    });
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      getCycleCountDetails();
      setSelectedLockedItems([]);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    loading,
    cycleCount,
    getCycleCountDetails,
    updateCycleCountStatus,
    printCycleCountSummary,
    printCycleCountDetails,
    askDeleteCycleCount,
    navigateUserAfterDeletion,
    askRelocateItem,
    selectedRelocationItems,
    setSelectedRelocationItems,
    relocateInProgress,
    askRelocateMultipleItems,
    selectedMissingItems,
    setSelectedMissingItems,
    askMarkItemMissing,
    selectedShippingItems,
    setSelectedShippingItems,
    selectedLockedItems,
    setSelectedLockedItems,
    askDeleteShippedItemsFromCC,
    askUnlockLockedItems,
    getCorrectItemsGroupedByPlu,
    getWrongItemsGroupedByPlu,
    getMissingItemsGroupedByPlu,
    getShippedItemsGroupedByPlu,
    getLockedItemsGroupedByPlu,
  };
}
